module.exports = __webpack_public_path__ + "static/img/einvest-pain-point-01.c25c950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/einvest-pain-point-01.png
// module id = 3xOj
// module chunks = 1